import type { Theme } from '@mui/material/styles';
import type { Components } from '@mui/material/styles/components';
import { COLORS } from './colors';

export const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
  styleOverrides: {
    inputRoot: {
      padding: '8px 0',
      '& .MuiAutocomplete-input': {
        padding: '0 0 0 12px',
      },
    },
    listbox: {
      maxHeight: '324px',
      overflowY: 'auto',
    },
    noOptions: {
      padding: '6px 16px',
    },
    groupLabel: ({ theme }: { theme: Theme }) => ({
      backgroundColor: COLORS.paleBlue300,
      ...theme.typography.body1,
      color: theme.palette.text.primary,
      padding: '6px 16px',
    }),
  },
};
